import { render } from "./EduRegisterDoneView.vue?vue&type=template&id=09dd21a9"
import script from "./EduRegisterDoneView.vue?vue&type=script&lang=js"
export * from "./EduRegisterDoneView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__